import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=20fc4fae&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=20fc4fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc4fae",
  null
  
)

export default component.exports